import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY-MMM-DD',
  },
  display: {
    dateInput: 'YYYY-MMM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'YYYY-MMM-DD',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-datepicker-overview',
  templateUrl: './datepicker-overview.component.html',
  styleUrls: ['./datepicker-overview.component.css'],
})
export class DatepickerOverviewComponent implements OnInit {
  pipe = new DatePipe('en-US');

_date1 = new Date();
_date2 = new Date();

  date1 = this.pipe.transform(this._date1, 'MM/dd/yyyy');
  date2 = this.pipe.transform(this._date2, 'MM/dd/yyyy');

  constructor() { }

  ngOnInit() {
  }

}
